export const defaultSelectedSeguimiento = () => {
    return {
        id_empresa: '',
        id_hallazgo: '',
        fecha_seguimiento: '',
        fecha_cierre: '',
        observacion: '',
        porc_implementacion: '',
        responsable: '',
        estado: '',
    }
}

export const defaultSelectedAdjunto = () => {
    return {
        id_empresa: '',
        id_seguimiento: '',
        descripcion: '',
        adjunto: ''
    }
}

export default {
    id_lista_chequeo:"",
    selectedSeguimiento: defaultSelectedSeguimiento(),
    selectedAdjunto: defaultSelectedAdjunto(),
    seguimientos: [],
    adjuntos:[],
    accion: 'Crear',
    error: false,

    filtro: {
        id_empresa: '',
        id_hallazgo: ''
    },
    imagenSeguimiento: {
        id_empresa: '',
        id_seguimiento: ''
    },
}
